import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { CreateHerdManagementSystem, HerdManagementSystem } from '../../../store/entities/hms/hms.type';
import { APIManagerConfig } from '../apiManager';

const HMSServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getHMS: (): Promise<HerdManagementSystem[]> =>
      HTTPBase.get(`farm/${config.farmId}/hms/groups`).then((res) => res.data),
    createHMS: (hms: CreateHerdManagementSystem, formName: FormName): Promise<HerdManagementSystem> =>
      HTTPBase.post(`farm/${config.farmId}/hms/groups`, hms, { headers: { formName } }).then((res) => res.data),
    editHMS: (id: number, hms: CreateHerdManagementSystem, formName: FormName): Promise<HerdManagementSystem> =>
      HTTPBase.patch(`farm/${config.farmId}/hms/groups/${id}`, hms, { headers: { formName } }).then((res) => res.data),
    deleteHMS: (id: number, formName: FormName): Promise<any> =>
      HTTPBase.delete(`farm/${config.farmId}/hms/groups/${id}`, { headers: { formName } }).then((res) => res.data),
  };
};

export default HMSServiceFactory;
